import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAreaCareer = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Frame",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M2.66667 18.6667C2.66667 14.9215 2.66667 13.0488 3.56549 11.7036C3.95461 11.1213 4.45461 10.6213 5.03696 10.2322C6.38215 9.33333 8.25477 9.33333 12 9.33333H20C23.7452 9.33333 25.6179 9.33333 26.9631 10.2322C27.5453 10.6213 28.0453 11.1213 28.4345 11.7036C29.3333 13.0488 29.3333 14.9215 29.3333 18.6667C29.3333 22.4119 29.3333 24.2845 28.4345 25.6297C28.0453 26.212 27.5453 26.712 26.9631 27.1012C25.6179 28 23.7452 28 20 28H12C8.25477 28 6.38215 28 5.03696 27.1012C4.45461 26.712 3.95461 26.212 3.56549 25.6297C2.66667 24.2845 2.66667 22.4119 2.66667 18.6667Z",
				stroke: "var(--stroke-0, #9565FD)",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M21.3333 9.33333C21.3333 6.81917 21.3333 5.56209 20.5523 4.78105C19.7712 4 18.5141 4 16 4C13.4859 4 12.2288 4 11.4477 4.78105C10.6667 5.56209 10.6667 6.81917 10.6667 9.33333",
				stroke: "var(--stroke-0, #9565FD)",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_3",
				d: "M8 14.6667L8.86929 14.936C13.4468 16.3547 18.5532 16.3547 23.1307 14.936L24 14.6667M16 16V18.6667",
				stroke: "var(--stroke-0, #9565FD)",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})
});
export default SvgAreaCareer;
